var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};































































pug_mixins["switchbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["double-label-switch",attributes.containerHtmlClass], [false,false]), false, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"switch round large\"\u003E\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+" type=\"checkbox\""+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("id", id, true, true)+pug.attr("name", id, true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-true-value", attributes['ng-true-value'], true, true)+pug.attr("ng-init", attributes['ng-init'], true, true)+pug.attr("ng-false-value", attributes['ng-false-value'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E\u003Clabel" + (" class=\"switch__label\""+pug.attr("for", id, true, true)) + "\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};






































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};
pug_mixins["select"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.attributes) {
attributes.attributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "form-group"},attributes.groupAttributes]), true)) + "\u003E\u003Clabel" + (" class=\"control-label\""+pug.attr("for", attributes.key, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cselect" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"name": pug.escape(id),"id": pug.escape(id),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"disabled": pug.escape(attributes.disabled),"required": pug.escape(attributes.required),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
if (attributes.titleMap) {
// iterate attributes.titleMap
;(function(){
  var $$obj = attributes.titleMap;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var option = $$obj[pug_index3];
if ('object' === typeof option) {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option.value, false, true)) + "\u003E" + (pug.escape(null == (pug_interp = option.name) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
else {
pug_html = pug_html + "\u003Coption" + (pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = option) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
}
    }
  }
}).call(this);

}
block && block();
pug_html = pug_html + "\u003C\u002Fselect\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}
























































pug_html = pug_html + "\u003Cdiv class=\"row\" ng-if=\"!$ctrl.customerLocations &amp;&amp; !$ctrl.traditional\"\u003E\u003Cdiv class=\"columns medium-10 medium-centered\"\u003E\u003Cdiv class=\"registrationWrapper\"\u003E\u003Choneypot-form\u003E\u003C!-- Abfrage--\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv overlay=\"$ctrl.working\" ng-hide=\"$ctrl.success\"\u003E\u003Ch1 class=\"mainform\"\u003E\u003C\u002Fh1\u003E\u003Cspan\u003EBitte registrieren Sie sich für das Portal.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-6\"\u003E\u003C!--span.linker(ng-click='$ctrl.oldWay()') Ich habe keinen Code--\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.enteredCode","divTitle": "Arbeitgeber-Code","type": "text","data-cy": "vn.registration.self.customerAssignment.inputCustomerCode","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie Ihren Arbeitgeber-Code ein"}}
});
pug_html = pug_html + "\u003Cspan class=\"error\" ng-if=\"$ctrl.errorCode\"\u003EBitte geben Sie einen gültigen Code an\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.way()\" ng-disabled=\"!$ctrl.canContinue()\" data-cy=\"vn.registration.self.customerAssignment.buttonNext\"\u003EWeiter\u003C\u002Fbutton\u003E\u003Ca class=\"button button-primary left\" href=\"\u002Fcidaas_login\" data-cy=\"vn.registration.self.customerAssignment.buttonCancel\"\u003EAbbrechen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","name": "wayForm","id": "wayForm"}
});
pug_html = pug_html + "\u003C\u002Fhoneypot-form\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.customerLocations &amp;&amp; !$ctrl.errorCode\"\u003E\u003Cdiv class=\"columns medium-10 medium-centered\"\u003E\u003Cdiv class=\"registrationWrapper\" overlay=\"$ctrl.loading\"\u003E\u003C!-- NEW WAY--\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv overlay=\"$ctrl.working\" ng-hide=\"$ctrl.success\"\u003E\u003Ch1 class=\"mainform\"\u003E\u003C\u002Fh1\u003E\u003Cspan\u003EBitte registrieren Sie sich für das Portal.\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv ng-hide=\"$ctrl.next == true\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-10\"\u003E\u003Cspan\u003EWählen Sie ggf. den korrekten Standort aus, an dem Sie beschäftigt sind.\u003C\u002Fspan\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.data.loc_id","title": "Standort","required": pug.escape(true),"data-cy": "vn.registration.self.customerAddress.selectCustomerAdress","validationMessages": {"required":"Wählen Sie einen Standort aus"},"attributes": {"ng-options":"location.value as location.name for location in $ctrl.customerLocations","tabindex":1}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cspan class=\"linker\" ng-if=\"$ctrl.customerLocations.length &gt; 1\" ng-click=\"$ctrl.next = false;$ctrl.location = &quot;&quot;\"\u003EZurück zur Standort auswahl\u003C\u002Fspan\u003E";
pug_mixins["select"].call({
attributes: {"key": "$ctrl.data.sex","title": "Anrede","data-cy": "vn.registration.self.employeeData.selectEmployeeSex","titleMap": [{"value":"1","name":"Herr"},{"value":"0","name":"Frau"}],"required": pug.escape(true),"validationMessages": {"required":"Geben Sie ein Geschlecht an"},"attributes": {"vn-number-to-bool":true,"vn-autofocus":true,"tabindex":2}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-4\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.firstname","title": "Vorname","data-cy": "vn.registration.self.employeeData.inputEmployeeFirstName","required": pug.escape(true),"validationMessages": {"required":"Geben Sie Ihren Vornamen an"},"attributes": {"tabindex":3}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-4\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.lastname","title": "Name","data-cy": "vn.registration.self.employeeData.inputEmployeeLastName","required": pug.escape(true),"validationMessages": {"required":"Geben Sie Ihren Nachnamen an"},"attributes": {"tabindex":4}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-8\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.login.email","title": "E-Mail Adresse Privat","type": "email","data-cy": "vn.registration.self.employeeData.inputEmployeeEmail","required": pug.escape(true),"validationMessages": {"email":"Bitte geben Sie eine gültige E-Mail Adresse an","required":"Geben Sie Ihren E-Mail Adresse an","unique":"Diese E-Mail-Adresse wird bereits verwendet","domain":"{{$ctrl.getDomainErrorMessage()}}","exist":"Sollte eine echte E-Mail-Adresse sein"},"attributes": {"ng-change":"$ctrl.handleEmailInputChange()","ng-model-options":"{ debounce: 300 }","tabindex":5}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E";
pug_mixins["switchbox"].call({
attributes: {"key": "$ctrl.data.login.is_work","data-cy": "vn.registration.self.employeeData.checkWorkEmail","title": "geschäftliche E-Mail Adresse"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-8\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.employeenumber","title": "Personalnummer","required": pug.escape(true),"data-cy": "vn.registration.self.employeeData.inputPersonalNumber","ng-change": "$ctrl.handlePersonalNumberInputChange()","validationMessages": {"required":"{{ configuration.personal_number_config && configuration.personal_number_config.is_enabled && configuration.personal_number_config.description || 'Geben Sie Ihre Personalnummer an, wie Sie auch auf Ihrer Abrechnung aufgedruckt ist.'}}","pattern":"{{ configuration.personal_number_config.description }}","unique":"Diese Personalnummer wird bereits verwendet"},"attributes": {"ng-pattern":"configuration.personal_number_config && configuration.personal_number_config.is_enabled ? configuration.personal_number_config.syntax : null","ng-change":"$ctrl.handlePersonalNumberChanged()","tabindex":7}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Cbutton class=\"button button-primary right\" type=\"button\" ng-click=\"$ctrl.checkPersonalNumber()\" style=\"margin-top: 15px; background-color: {{ $ctrl.isValidationResult.isValid ? &quot;green&quot; : &quot;#003b55&quot; }}\"\u003E{{ $ctrl.isValidationResult.isValid ? 'Validiert' : 'Validieren'  }}\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-10\"\u003E\u003Cspan class=\"error\" ng-show=\"$ctrl.isValidationResult.error\"\u003E{{ $ctrl.isValidationResult.message }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isValidationResult.isValid\"\u003E\u003Cdiv class=\"columns medium-10\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"birthdateInput\" date-refocus=\"true\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.birthdate","title": "Geburtsdatum","data-cy": "vn.registration.self.employeeData.inputEmployeeBirthDate","attributes": {"vn-date":"true","vn-date-reformat":"true","vn-date-string-model":"true","vn-date-year-range":"true","vn-date-age-min":14,"vn-date-age-max":90,"ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","tabindex":8},"fieldHtmlClass": "birthdateInput","validationMessages": {"parse":"Bitte Geburtsdatum im Format tt.mm.jjjj eingeben","age":"Bitte überprüfen Sie die Eingabe"}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isValidationResult.isValid\"\u003E\u003Cdiv class=\"columns medium-10\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.kostenstelle","title": "{{configuration.organization_structure.cost_center.label}}","validationMessages": {"required":"Bitte {{configuration.organization_structure.cost_center.label}} hier eintragen."},"data-cy": "vn.registration.self.employeeData.inputAccountingUnit","attributes": {"tabindex":9,"ng-required":"configuration.organization_structure.cost_center.is_required"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isValidationResult.isValid\"\u003E\u003Cdiv class=\"columns medium-10\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.org_einheit","title": "{{configuration.organization_structure.organization.label}}","data-cy": "vn.registration.self.employeeData.inputCompanyDepartment","validationMessages": {"required":"Bitte {{configuration.organization_structure.organization.label}} hier eintragen."},"attributes": {"tabindex":10,"ng-required":"configuration.organization_structure.organization.is_required"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isValidationResult.isValid\"\u003E\u003Cdiv class=\"columns medium-10\"\u003E\u003Cdatepicker date-format=\"dd.MM.yyyy\" selector=\"entrydateInput\" date-refocus=\"false\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "$ctrl.data.entrydate","title": "Datum Firmeneintritt","data-cy": "vn.registration.self.employeeData.inputCompanyEntryDate","attributes": {"vn-date-helper":"true","ng-model-options":"{allowInvalid: true}","ng-pattern":"\u002F^(0?[1-9]|[12][0-9]|3[01])\\.([0]?[0-9]|1[0-2])\\.\\d{4}$\u002F","tabindex":11},"fieldHtmlClass": "entrydateInput","validationMessages": {"required":"Bitte Eintrittsdatum angeben","pattern":"Bitte Eintrittsdatum im Format tt.mm.jjjj eingeben"}}
});
pug_html = pug_html + "\u003C\u002Fdatepicker\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isValidationResult.isValid\"\u003E\u003Cdiv class=\"columns medium-10\"\u003E\u003Cdiv class=\"form-group\" ng-click=\"$ctrl.toggleRead($event)\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Cinput type=\"checkbox\" ng-model=\"$ctrl.data.toc\" id=\"registrationdatatoc\" data-cy=\"vn.registration.self.employeeData.checkToc\" tabindex=\"12\" required\u003E\u003Clabel for=\"registrationdatatoc\"\u003E\u003Cspan class=\"reg-text\"\u003EIch habe die&nbsp;\u003Cspan class=\"blue\" style=\"font-weight:bold; text-decoration:underline;\"\u003EDatenschutzerklärung\u003C\u002Fspan\u003E&nbsp;zur Kenntnis genommen und bestätige dies mit dem Absenden der Nachricht. Ich stimme zu, dass meine Angaben und Daten zur Beantwortung meiner Anfrage elektronisch erhoben und gespeichert werden. Die Einwilligung kann ich jederzeit für die Zukunft widerrufen.\u003Cbr\u003E\u003Cbr\u003E(Öffnen Sie die Datenschutzerklärung über den Link. Nach dem Lesen können Sie am Ende der Erklärung bestätigen.)\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isValidationResult.isValid\"\u003E\u003Cdiv class=\"columns medium-9\"\u003E" + (null == (pug_interp = require("./newslettertogo_subscription.pug").call(this, locals)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$ctrl.isValidationResult.isValid\"\u003E\u003Cspan class=\"error\" ng-show=\"$ctrl.error\"\u003EIhre Eingaben konnten nicht gespeichert werden.\u003C\u002Fspan\u003E\u003Cbutton class=\"button button-primary right\" type=\"submit\" form=\"selfRegistrationForm\" ng-disabled=\"!$ctrl.canSave()\" data-cy=\"vn.registration.self.employeeData.buttonSubmit\"\u003EBeantragen\u003C\u002Fbutton\u003E\u003Ca class=\"button button-primary left\" href=\"\u002Fcidaas_login\" data-cy=\"vn.registration.self.employeeData.buttonCancel\"\u003EAbbrechen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--.clearfix--\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-show=\"$ctrl.success\"\u003E\u003Cp\u003EVielen Dank für Ihre Registrierung. Ihre Daten wurden erfolgreich\nübermittelt. Wir prüfen nun Ihre Angaben und übersenden Ihnen in Kürze\neine E-Mail zu Ihrer Registrierung.\u003C\u002Fp\u003E\u003Ca href=\"\u002F\"\u003EZurück\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
},
attributes: {"class": "form-padding","name": "$ctrl.forms.selfRegistrationForm","id": "selfRegistrationForm","ng-submit": "$ctrl.selfSave()"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-12\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;